import { Component, inject, Input } from '@angular/core';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { InputNumberInputEvent } from 'primeng/inputnumber';
import { TunnelDisplayedProduct } from '../../../models/tunnel-displayed-product';
import { TunnelCartService } from '../../../services/tunnel-cart.service';

/** Carte produit de la recherche de l'étape « Liste d'achat ». */
@Component({
  selector: 'ng-casto-tunnel-product-card',
  templateUrl: './tunnel-product-card.component.html',
  styleUrls: ['./tunnel-product-card.component.scss'],
})
export class TunnelProductCardComponent {
  @Input() product?: TunnelDisplayedProduct;
  @Input() skeleton?: boolean;

  private readonly tunnelCartService = inject(TunnelCartService);

  protected readonly faMinus = faMinus;
  protected readonly faPlus = faPlus;

  private static readonly PLACEHOLDER_IMAGE_SRC = 'assets/img/placeholders/item-list@2x.png';

  /** Source de l'image du produit, ou l'image par défaut si le produit n'en a pas. */
  protected get imageSource(): string {
    return this.product?.product?.imgPaths?.length
      ? this.product.product.imgPaths[0]
      : TunnelProductCardComponent.PLACEHOLDER_IMAGE_SRC;
  }

  /** Prix total de la ligne. */
  protected get subTotal(): number {
    return this.product.product.price * this.product.quantity;
  }

  /** Remplace l'image par l'image par défaut lorsque son chargement échoue. */
  protected setImageLoadError(event: Event): void {
    (event.target as HTMLImageElement).src = TunnelProductCardComponent.PLACEHOLDER_IMAGE_SRC;
  }

  protected incrementProductQuantity(): void {
    this.changeQuantity(this.product.quantity + 1);
  }

  protected decrementProductQuantity(): void {
    this.changeQuantity(this.product.quantity - 1);
  }

  protected onInputChange(event: InputNumberInputEvent): void {
    this.changeQuantity(event.value as number);
  }

  protected changeQuantity(quantity: number): void {
    if (this.product.quantity === 0 && quantity > 0) {
      this.tunnelCartService.addProduct(this.product.product, quantity);
      return;
    }

    this.tunnelCartService.setQuantity(this.product.product.ean, quantity);
  }
}
